import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import LegalLayout from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <Layout>
      <LegalLayout title="Politique de confidentialité" testId="privacy-page">
        <p>
          Doudou Alert respecte votre vie privée et applique le Règlement Général sur la Protection des Données
          (RGPD - UE 2016/679) ainsi que la loi française Informatique et Libertés.
        </p>

        <h2>1. Responsable du traitement</h2>
        <p>
          Le responsable du traitement est l'éditeur de Doudou Alert. Pour toute question, contactez
          <strong> contact@doudou-alert.fr</strong>.
        </p>

        <h2>2. Données collectées</h2>
        <h3>Pour les familles inscrites</h3>
        <ul>
          <li>Prénom, email (et mot de passe haché par bcrypt) ou identifiant Google (nom, photo de profil) ;</li>
          <li>Numéro de téléphone (facultatif) ;</li>
          <li>Fiches doudous : nom, description, département, photo (facultatif), statut, dernière position connue (latitude/longitude), détail privé d'identification (facultatif).</li>
        </ul>
        <h3>Pour les personnes qui trouvent un doudou (anonymes)</h3>
        <ul>
          <li><strong>Prénom</strong> (affiché publiquement dans le chat) ;</li>
          <li><strong>Nom de famille</strong> (privé, jamais affiché, conservé à des fins de litige éventuel) ;</li>
          <li><strong>Adresse email</strong> (privée, utilisée uniquement pour notifier la personne lors d'un nouveau message reçu) ;</li>
          <li>Photo et description du doudou trouvé ;</li>
          <li>Localisation indicative du lieu de découverte (latitude/longitude) ;</li>
          <li>Jeton anonyme (« finder_token ») stocké uniquement sur l'appareil de la personne, permettant de poursuivre la conversation sans inscription.</li>
        </ul>
        <p className="text-sm bg-rose-50 border border-rose-200 rounded-2xl p-4">
          ⚖️ <strong>Conservation à des fins probatoires :</strong> le nom de famille et l'adresse email des
          personnes ayant signalé un doudou sont conservés pendant 3 ans après le dernier échange et peuvent
          être communiqués aux autorités compétentes sur réquisition judiciaire en cas de litige ou de signalement
          de comportement illicite (contenu pédopornographique, harcèlement, escroquerie, etc.).
        </p>

        <h2>3. Finalités</h2>
        <ul>
          <li>Permettre la création, la consultation et le partage de fiches doudou ;</li>
          <li>Permettre la communication entre les familles et les personnes ayant trouvé un doudou ;</li>
          <li>Assurer la sécurité du service (authentification, prévention des abus).</li>
        </ul>

        <h2>4. Base légale</h2>
        <ul>
          <li><strong>Exécution du contrat</strong> (CGU) pour la création de compte et l'utilisation du service ;</li>
          <li><strong>Consentement</strong> pour la collecte des données de géolocalisation et la publication d'informations sur le service ;</li>
          <li><strong>Obligation légale</strong> pour la conservation des justificatifs comptables liés aux paiements.</li>
        </ul>

        <h2>5. Destinataires</h2>
        <p>
          Vos données ne sont jamais vendues. Elles peuvent être communiquées à nos sous-traitants techniques,
          qui agissent sous notre contrôle :
        </p>
        <ul>
          <li><strong>Stripe</strong> (paiements) - serveurs UE/US, conforme RGPD ;</li>
          <li><strong>MongoDB Atlas</strong> (hébergement base de données) - région UE ;</li>
          <li><strong>Google</strong> (authentification OAuth) - si vous choisissez cette option ;</li>
          <li><strong>OpenStreetMap</strong> (tuiles cartographiques) - aucune donnée personnelle transmise.</li>
        </ul>

        <h2>6. Durée de conservation</h2>
        <ul>
          <li>Compte utilisateur : tant que le compte est actif, puis 12 mois après suppression ;</li>
          <li>Fiches doudou : tant que présentes dans votre compte ;</li>
          <li>Messages : 24 mois maximum, sauf demande de suppression anticipée ;</li>
          <li>Justificatifs comptables : 10 ans (obligation légale).</li>
        </ul>

        <h2>7. Cookies et stockage local</h2>
        <ul>
          <li><strong>Cookie de session</strong> (« session_token ») pour les utilisateurs connectés via Google - durée 7 jours, httpOnly, secure ;</li>
          <li><strong>localStorage</strong> : token JWT (connexion email/mdp), jetons « finder_token » pour les conversations anonymes - effaçables via les paramètres du navigateur.</li>
        </ul>
        <p>Aucun cookie publicitaire ou de tracking tiers n'est utilisé.</p>

        <h2>8. Vos droits</h2>
        <p>Conformément au RGPD, vous disposez des droits suivants :</p>
        <ul>
          <li><strong>Accès</strong> à vos données ;</li>
          <li><strong>Rectification</strong> via votre page profil ;</li>
          <li><strong>Effacement</strong> (« droit à l'oubli ») via la suppression de compte ou demande par email ;</li>
          <li><strong>Portabilité</strong> de vos données (export sur demande) ;</li>
          <li><strong>Opposition</strong> et <strong>limitation</strong> du traitement ;</li>
          <li>Définir des <strong>directives post-mortem</strong>.</li>
        </ul>
        <p>
          Adressez vos demandes à <strong>contact@doudou-alert.fr</strong>. Vous pouvez également déposer une
          réclamation auprès de la CNIL (<a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>).
        </p>

        <h2>9. Sécurité</h2>
        <p>
          Les mots de passe sont hachés avec bcrypt. Les communications sont chiffrées (HTTPS). Les paiements
          sont traités par Stripe (PCI-DSS niveau 1). Aucune donnée bancaire n'est stockée sur nos serveurs.
        </p>

        <h2>10. Mineurs</h2>
        <p>
          Le service est destiné aux <strong>parents et adultes</strong>. Il n'est pas conçu pour être utilisé
          directement par des mineurs de moins de 15 ans. Les fiches doudou ne contiennent aucune donnée
          personnelle d'enfant.
        </p>

        <p className="text-sm text-stone-500 mt-8">
          Voir aussi : <Link to="/cgu">CGU</Link> · <Link to="/mentions-legales">Mentions légales</Link>
        </p>
      </LegalLayout>
    </Layout>
  );
}
